<template>
    <c-dialog ref="dialog" mode="slide" width="1200" :button="false">
        <div class="m-log-content">
            <div v-if="productInfo || productCode" class="m-log-head">
                <span v-if="productInfo">{{productInfo}}</span>
                <span v-if="productCode" class="m-log-code">背贴码：{{productCode}}</span>
            </div>
            <c-title>推送记录</c-title>
            <c-table ref="list" border :paging="false">
                <c-table-column label="推送渠道" name="channel_name" width="130"></c-table-column>
                <c-table-column label="推送类型" width="100">
                    <template #default="{data}">
                        <c-state dict="salePushTypeDic" :value="data.push_type"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="推送价格" width="110">
                    <template #default="{data}">
                        <span style="color: #e53e3e;">{{formatPrice(data.push_price)}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="推送状态" width="100">
                    <template #default="{data}">
                        <c-state dict="salePushStateDic" :value="data.push_state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="失败原因" name="fail_reason" width="460"></c-table-column>
                <c-table-column label="推送时间" name="create_date" width="150"></c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpSalePushLog',

    data() {
        return {
            productInfo: '',
            /**背贴码：列表行带入，与商品名一并展示*/
            productCode: ''
        };
    },

    methods: {
        /*********打开弹框（data=运营端商品列表行，按商户切租户查推送记录）**********/
        open(data = {}) {
            this.productInfo = data.product_info || '';
            this.productCode = data.produce_unique_code || '';
            this.$refs.dialog.open({title: '推送记录'});
            this.$nextTick(() => {
                this.$refs.list.load({
                    url: '/sale/push/ops/listByProduct',
                    data: {
                        merchant_id: data.saas_id,
                        product_id: data.id
                    }
                });
            });
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        }
    }
};
</script>

<style lang="stylus" scoped>
.m-log-content
    padding 20px

.m-log-head
    padding 10px 0 16px
    font-size 18px
    font-weight 600
    color #333
    text-align center

    /*背贴码单独一行展示，不与商品名挤在同一行；与商品名行拉开行距*/
    .m-log-code
        display block
        margin-top 8px
        line-height 1.4
        font-size 14px
        font-weight normal
        color #666
</style>
